const prod = process.env.NODE_ENV === 'production'
const windowEnv = window.Environment ? window.Environment : false
let isDevEnv = false
if (windowEnv === 'dev') {
    isDevEnv = true
}
const isDev = function () {
    return isDevEnv
}

const reInitModules = function (reinit) {
    const modulesToReInit = reinit.split(',')
    if (isDev()) {
        console.log(`library/index.js - reInitModules - loaded ${reinit}`)
    }
    const moduleElements = document.querySelectorAll('[data-module]')
    for (let i = 0; i < moduleElements.length; i++) {
        const el = moduleElements[i]
        const name = el.getAttribute('data-module')
        if (modulesToReInit.includes(name) || reinit === 'all') {
            if (isDev()) {
                console.log(name)
            }
            const Module = require(`../modules/${name}`).default
            new Module(el)
        }
    }
}

export {
    reInitModules,
}
